import { render, staticRenderFns } from "./salaryEdit.vue?vue&type=template&id=1007667a&scoped=true"
import script from "./salaryEdit.vue?vue&type=script&lang=js"
export * from "./salaryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007667a",
  null
  
)

export default component.exports